module.exports = __webpack_public_path__ + "img/大图--少女.c95664cd.png";